/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A debonding delegation.
 * @export
 * @interface DebondingDelegation
 */
export interface DebondingDelegation {
    /**
     * The amount of tokens delegated in base units.
     * @type {string}
     * @memberof DebondingDelegation
     */
    amount: string;
    /**
     * The shares of tokens delegated.
     * @type {string}
     * @memberof DebondingDelegation
     */
    shares: string;
    /**
     * The delegatee (validator) address.
     * @type {string}
     * @memberof DebondingDelegation
     */
    validator: string;
    /**
     * The delegator address.
     * @type {string}
     * @memberof DebondingDelegation
     */
    delegator: string;
    /**
     * The epoch at which the debonding ends.
     * @type {number}
     * @memberof DebondingDelegation
     */
    debond_end: number;
}

export function DebondingDelegationFromJSON(json: any): DebondingDelegation {
    return DebondingDelegationFromJSONTyped(json, false);
}

export function DebondingDelegationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DebondingDelegation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'shares': json['shares'],
        'validator': json['validator'],
        'delegator': json['delegator'],
        'debond_end': json['debond_end'],
    };
}

export function DebondingDelegationToJSON(value?: DebondingDelegation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
        'shares': value.shares,
        'validator': value.validator,
        'delegator': value.delegator,
        'debond_end': value.debond_end,
    };
}


